import {
  FormQuestion,
  FormSlug,
  ImplementationGuideForm,
  ImplementationGuideFormData,
} from "../../types";
import { CardResource } from "../../types/CardResource.interface";

const getFormResources = (
  data: Record<FormSlug, ImplementationGuideFormData>,
  form: ImplementationGuideForm,
  resourceFilterFn: (resource: CardResource) => boolean,
): CardResource[] => {
  const formResponses = data[form.slug];
  const questionResources = form.questions.reduce(
    (accumulator: CardResource[], question: FormQuestion) => {
      const resources =
        question.resources?.filter((resource: CardResource) =>
          Object.values(formResponses).includes(resource.response_option),
        ) ?? [];
      return [...accumulator, ...resources];
    },
    [],
  );
  const formResources = form.resources
    ? form.resources.filter(resourceFilterFn)
    : [];

  return [...questionResources, ...formResources];
};

export default getFormResources;
